
  import { Options, Vue } from 'vue-class-component';
  import HelloWorld from '../../components/HelloWorld.vue';
  import {DataUtil} from '@/util/DataUtil';
  import {agreementConfig} from '@/config/template';

  @Options({
    components: {
      HelloWorld,
    }
  })
  export default class App extends Vue {
      private temp: string = agreementConfig.template_0617;

      private config: TemplateInterface = {
          productName: '我在明朝有条街',
          companyFullName: '海南云生网络技术有限公司',
          companyShortName: '海南云生',
          officialWebsite: 'https://www.hainanyunsheng.com/',
      };

    mounted(){
      this.temp = DataUtil.replaceConfig(this.temp, this.config);
    }
  }
